var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 61,
    viewBox: "0 0 52 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01388 49.0207V6.0207C2.21404 1.6207 5.51381 0.854031 7.01367 1.0207H32.0137L41.5137 10.5207V55.5207H8.51388C2.11388 55.5207 0.847212 51.1874 1.01388 49.0207Z",
    fill: "#F3F5F7",
    stroke: "#E5E7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 11.0205V1.02051L42 11.0205H32Z",
    fill: "#E5E7E7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 45.0205,
    r: 15.5,
    fill: "#151A26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9937 48.3955C42.7673 48.3955 43.5091 48.0882 44.0561 47.5412C44.6031 46.9943 44.9104 46.2524 44.9104 45.4788C44.9104 44.7053 44.6031 43.9634 44.0561 43.4164C43.5091 42.8695 42.7673 42.5622 41.9937 42.5622H41.1604C41.282 42.0205 41.2838 41.4625 41.1658 40.9202C41.0478 40.3778 40.8123 39.8617 40.4727 39.4013C40.1331 38.9409 39.696 38.5451 39.1865 38.2367C38.6769 37.9283 38.1049 37.7133 37.503 37.6038C36.9011 37.4944 36.2811 37.4927 35.6785 37.5989C35.0759 37.7051 34.5025 37.9171 33.9909 38.2228C32.9577 38.8401 32.2393 39.8015 31.9937 40.8955C31.1054 40.8599 30.2317 41.1208 29.5223 41.6336C28.8129 42.1463 28.3119 42.879 28.1051 43.7062C27.8983 44.5334 27.9986 45.4036 28.3887 46.1678C28.7789 46.9321 29.4346 47.5428 30.2437 47.8955M36.1604 44.2288V51.7288M36.1604 51.7288L33.6604 49.2288M36.1604 51.7288L38.6604 49.2288",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.5f98d90e393178fa38d02347dee8d292.svg";
export { ForwardRef as ReactComponent };